import {BrickContext, ActionBrick, registerBrick, ErrorFlow} from 'olympe';



export default class STTLocalWhisper extends ActionBrick {

    static instance;
    static context;

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(string)} setText
     */
    async update($, [file], [forwardEvent, setErrorFlow, setText]) {

        const Module = {};

        if (!STTLocalWhisper.instance) {
            STTLocalWhisper.instance = Module.init('whisper.bin');

            if (STTLocalWhisper.instance) {
                console.log('js: whisper initialized, instance: ' + STTLocalWhisper.instance)
            }
        }

        if (!STTLocalWhisper.instance) {
            console.error("js: failed to initialize whisper");
            return;
        }

        if (!file) {
            console.error("js: no audio data");
            return;
        }

        if (!STTLocalWhisper.context) {
            STTLocalWhisper.context = new AudioContext({
                sampleRate: 16000,
                channelCount: 1,
                echoCancellation: false,
                autoGainControl:  true,
                noiseSuppression: true,
            });
        }

        if (STTLocalWhisper.instance) {
            console.log('js: processing - this might take a while ...');

            file.getContentAsBinary((ab) => {
                STTLocalWhisper.context.decodeAudioData(
                    ab,
                    (audioBuffer) => {
                        const offlineContext = new OfflineAudioContext(audioBuffer.numberOfChannels, audioBuffer.length, audioBuffer.sampleRate);
                        const source = offlineContext.createBufferSource();
                        source.buffer = audioBuffer;
                        source.connect(offlineContext.destination);
                        source.start(0);

                        offlineContext.startRendering().then(function(renderedBuffer) {
                            const audio = renderedBuffer.getChannelData(0);
                            console.log('js: audio recorded, size: ' + audio.length);


                            setTimeout(function() {
                                try {
                                    const ret = Module.full_default(STTLocalWhisper.instance, audio, 'en', 8, false);
                                    console.log('js: full_default returned: ' + ret);
                                    if (ret !== 0) {
                                        setText(ret);
                                        forwardEvent();
                                    }
                                } catch (e) {
                                    setErrorFlow(ErrorFlow.create('An error occurred while trying to get text out of the audio', 500));
                                }
                            }, 100);
                        });
                    },
                    (e) => {
                        console.error('js: error decoding audio: ' + e);
                    }
                );
            });

        }

    }




}

registerBrick('0190d9d721765bc0bcdf', STTLocalWhisper);
